import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  loginUserApi,
  logoutUserApi,
  getUserProfileApi,
  updatePasswordApi,
  getAllClientsApi,
  getAllUsersApi,
  getIndividualClientsApi,
  assignClientsToUserApi,
  getAssignedClientsToUserApi,
  getAllFinacUsersApi,
  changeFinacFirstLastNameApi,
  changeFinacUserPasswordApi,
  changeUserStatusApi,
  forgetPasswordApi,
  resetForgetPasswordApi,
  loginWithMobileNumberApi,
  loginWithMobileOtpVerifyApi,
  userProfileApi,
  updateProfileApi,
  getAllUserOfSingleClientApi,
  addRemoveFromFavourite,
  addUserApi,
  unassignedUserOfClient,
  checkUniqueEmailAndMobileNoApi,
  addAttendanceTime,
  getAttendanceData,
  checkRecruitmentTrackerUniqueEmailAndMobileNoApi,
  checkUniqueEmailAndMobileNoSignUpApi,
  getAllCountrySignUpApi,
  getAllCitySignUpApi,
  getAllStateSignUpApi,
  signUpClientApi,
  getTeamDirectoryUserList,
  getOtpSignUpApi,
  signUpOtpVerifyApi,
  getGovtOfficerJobsListApi,
  getVerifyAuAccountNumberApi,
  getPincodeApi,
  signAuVerifyVoucherCodeApi,
  createOrder,
  verifyOrder,
  getSignUpStatusApi,
} from "../../apis/authApis";
import {
  AddAttendanceTimePayloadType,
  AddRemoveFromFavouritePayloadType,
  AssignClientsToUserPayloadType,
  ChangeFinacUserFirstLastNameType,
  ChangeFinacUserPasswordType,
  ChangePasswordPayloadType,
  ChangeUserStatusType,
  CheckUniquiEmailAndMobilePayloadType,
  GetAllFinacUserPayloadType,
  GetAllUserOfSingleClientListPayloadType,
  GetAssignedClientsToUserPayloadType,
  GetAttendanceTimePayloadType,
  GetCityListSignUpDataPayloadType,
  GetCountryListSignUpDataPayloadType,
  GetGovtOfficerJobListPayloadType,
  getIndividualClientsPayload,
  GetPincodePayloadType,
  GetSignUpOtpPayloadType,
  GetAccountNoPaymentVoucherPayloadType,
  GetStateListSignUpDataPayloadType,
  GetTeamDirectoryPayloadType,
  LoginPayloadType,
  LoginWithMobileNumberPayloadType,
  LoginWithMobileOtpVerifyPayloadType,
  ResetForgetPasswordPayloadType,
  SignUpOtpVerifyPayloadType,
  SignUpUserPayloadType,
  UnassignedUserOfSingleClient,
  UserPayLoadType,
} from "../../commonTypes/authTypes";

async function setCsrfToken(response: any) {
  localStorage.removeItem("csrfToken");
  localStorage.setItem(
    "csrfToken",
    response?.headers["x-csrf-token"]?.toString()
  );
  return null;
}

export const loginUserAction = createAsyncThunk(
  "auth/loginUser",
  async (data: LoginPayloadType) => {
    const response = await loginUserApi(data);
    await setCsrfToken(response);
    return response.data;
  }
);

export const loginWithMobileNumberAction = createAsyncThunk(
  "auth/loginWithMobileNumber",
  async (data: LoginWithMobileNumberPayloadType) => {
    const response = await loginWithMobileNumberApi(data);
    return response.data;
  }
);

export const loginWithMobileOtpVerifyAction = createAsyncThunk(
  "auth/loginWithMobileOtpVerify",
  async (data: LoginWithMobileOtpVerifyPayloadType) => {
    const response = await loginWithMobileOtpVerifyApi(data);
    await setCsrfToken(response);
    return response.data;
  }
);

export const logoutUserAction = createAsyncThunk(
  "auth/logoutUser",
  async (token: string | null) => {
    const response = await logoutUserApi(token);
    return response.data;
  }
);

export const forgetPasswordAction = createAsyncThunk(
  "auth/forgetPassword",
  async (email: string | null) => {
    const response = await forgetPasswordApi(email);
    return response.data;
  }
);

export const resetForgetPasswordAction = createAsyncThunk(
  "auth/resetForgetPassword",
  async (data: ResetForgetPasswordPayloadType) => {
    const response = await resetForgetPasswordApi(data);
    return response.data;
  }
);

export const getUserProfileAction = createAsyncThunk(
  "auth/getUserProfile",
  async (token: string) => {
    const response = await getUserProfileApi(token);
    return response.data;
  }
);
export const userProfileAction = createAsyncThunk(
  "auth/userProfile",
  async (data: any) => {
    const response = await userProfileApi(data);
    return response.data;
  }
);
export const updateProfile = createAsyncThunk(
  "auth/updateUserProfile",
  async (data: any) => {
    const response = await updateProfileApi(data);
    return response.data;
  }
);
export const addUserPofile = createAsyncThunk(`add/user`, async (data: any) => {
  const response = await addUserApi(data);
  return response.data;
});

export const updatePasswordAction = createAsyncThunk(
  "auth/updatePassword",
  async (data: ChangePasswordPayloadType) => {
    const response = await updatePasswordApi(data);
    return response.data;
  }
);

export const getAllClientsAction = createAsyncThunk(
  "auth/getAllClients",
  async (data: {
    token: string;
    limit?: number;
    offset?: number;
    status?: number;
    search_term?: string;
  }) => {
    const response = await getAllClientsApi(data);
    return response.data;
  }
);

export const getAllUserAction = createAsyncThunk(
  `auth/getAllUsers`,
  async (data: UserPayLoadType) => {
    const response = await getAllUsersApi(data);
    return response.data;
  }
);

export const getAllAssignUserOfSingleClientAction = createAsyncThunk(
  `auth/getAllUserOfClient`,
  async (data: GetAllUserOfSingleClientListPayloadType) => {
    const response = await getAllUserOfSingleClientApi(data);
    return response.data;
  }
);

export const unassignedUserOfSingleClient = createAsyncThunk(
  `auth/unassignedUserOfClient`,
  async (data: UnassignedUserOfSingleClient) => {
    const response = await unassignedUserOfClient(data);
    return response.data;
  }
);

export const getIndividualClientsAction = createAsyncThunk(
  "clients/getIndividualClients",
  async (data: getIndividualClientsPayload) => {
    const response = await getIndividualClientsApi(data);
    return response.data;
  }
);

export const assignClientsToUserAction = createAsyncThunk(
  "clients/assignClientsToUser",
  async (data: AssignClientsToUserPayloadType) => {
    const response = await assignClientsToUserApi(data);
    return response.data;
  }
);

export const getAssignedClientsToUserAction = createAsyncThunk(
  "clients/getAssignedClientsToUser",
  async (data: GetAssignedClientsToUserPayloadType) => {
    const response = await getAssignedClientsToUserApi(data);
    return response.data;
  }
);

///get internal and external user action
export const getAllFinacUsersAction = createAsyncThunk(
  "auth/getAllFinacUsersList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

///get stco manager list action
export const getAllFinacManagerAction = createAsyncThunk(
  "auth/getAllFinacManagerList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

// get partner list
export const getAllFinacPartnerAction = createAsyncThunk(
  "auth/getAllFinacPartnerList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

// get govt officer list
export const getAllFinacGovtOfficerAction = createAsyncThunk(
  "auth/getAllFinacGovtOfficerList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

// get internal UserList
export const getFinacInternalUsersAction = createAsyncThunk(
  "auth/getFinacInternalUsersList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);
// get external Userlist
export const getFinacExternalUsersAction = createAsyncThunk(
  "auth/getFinacExternalUsersAction",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

export const getAllFinacClientsAction = createAsyncThunk(
  "auth/getAllFinacClientsList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);
export const getAllFinacClientUsersAction = createAsyncThunk(
  "auth/getAllFinacClientUsersList",
  async (data: GetAllFinacUserPayloadType) => {
    const response = await getAllFinacUsersApi(data);
    return response.data;
  }
);

export const changeFinacUserPasswordAction = createAsyncThunk(
  "auth/changeFinacUserPassword",
  async (data: ChangeFinacUserPasswordType) => {
    const response = await changeFinacUserPasswordApi(data);
    return response.data;
  }
);

export const changeFinacFirstLastNameAction = createAsyncThunk(
  "auth/changeFinacFirstLastName",
  async (data: ChangeFinacUserFirstLastNameType) => {
    const response = await changeFinacFirstLastNameApi(data);
    return response.data;
  }
);

export const changeUserStatusAction = createAsyncThunk(
  "auth/changeUserStatus",
  async (data: ChangeUserStatusType) => {
    const response = await changeUserStatusApi(data);
    return response.data;
  }
);

export const addRemoveToFavouriteAction = createAsyncThunk(
  "auth/addToFavourite",
  async (data: AddRemoveFromFavouritePayloadType) => {
    const response = await addRemoveFromFavourite(data);
    return response.data;
  }
);

export const checkUniqueEmailAction = createAsyncThunk(
  "auth/checkUniqueEmail",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkUniqueEmailAndMobileNoApi(data);
    return response;
  }
);

export const checkUniqueMobileNoAction = createAsyncThunk(
  "auth/checkUniqueMobileNo",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkUniqueEmailAndMobileNoApi(data);
    return response;
  }
);
export const checkRecruitmentTrackerUniqueEmailAction = createAsyncThunk(
  "auth/checkRecruitmentTrackerUniqueEmail",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkRecruitmentTrackerUniqueEmailAndMobileNoApi(
      data
    );
    return response;
  }
);

export const checkRecruitmentTrackerUniqueMobileNoAction = createAsyncThunk(
  "auth/checkRecruitmentTrackerUniqueMobileNo",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkRecruitmentTrackerUniqueEmailAndMobileNoApi(
      data
    );
    return response;
  }
);

export const addAttendanceTimeAction = createAsyncThunk(
  "auth/addAttendanceTime",
  async (data: AddAttendanceTimePayloadType) => {
    const response = await addAttendanceTime(data);
    return response.data;
  }
);

export const getAttendanceDataAction = createAsyncThunk(
  "auth/getAttendanceData",
  async (data: GetAttendanceTimePayloadType) => {
    const response = await getAttendanceData(data);
    return response.data;
  }
);


// 
export const checkUniqueEmailSignUpAction = createAsyncThunk(
  "auth/checkUniqueEmail",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkUniqueEmailAndMobileNoSignUpApi(data);
    return response;
  }
);

export const checkUniqueMobileNoSignUpAction = createAsyncThunk(
  "auth/checkUniqueMobileNo",
  async (data: CheckUniquiEmailAndMobilePayloadType) => {
    const response = await checkUniqueEmailAndMobileNoSignUpApi(data);
    return response;
  }
);

// sign country
export const getAllCountrySignUpAction = createAsyncThunk(
  "get/country",
  async (data: GetCountryListSignUpDataPayloadType) => {
    const response = await getAllCountrySignUpApi(data);
    return response.data;
  }
);

export const getAllCitySignUpAction = createAsyncThunk(
  "get/city",
  async (data: GetCityListSignUpDataPayloadType) => {
    const response = await getAllCitySignUpApi(data);
    return response.data;
  }
);



export const getAllStateSignUpAction = createAsyncThunk(
  "get/state",
  async (data: GetStateListSignUpDataPayloadType) => {
    const response = await getAllStateSignUpApi(data);
    return response.data;
  }
);


export const signUpClientAction = createAsyncThunk(
  "auth/signUpClient",
  async (data: SignUpUserPayloadType) => {
    const response = await signUpClientApi(data);
    await setCsrfToken(response);

    return response.data;
  }
);


export const getOtpSignUpAction = createAsyncThunk(
  "auth/getOtpSignUp",
  async (data: GetSignUpOtpPayloadType) => {
    const response = await getOtpSignUpApi(data);
    return response.data;
  }
);

export const getAccountNoPaymentVoucherAction = createAsyncThunk(
  "auth/getAccountNoPaymentVoucherAction",
  async (data: GetAccountNoPaymentVoucherPayloadType) => {
    const response = await getSignUpStatusApi(data);
    return response.data;
  }
);



export const getVerifyAuAccountNumberAction = createAsyncThunk(
  "auth/getVerifyAuAccountNumber",
  async (data: GetSignUpOtpPayloadType) => {
    const response = await getVerifyAuAccountNumberApi(data);
    return response.data;
  }
);

export const signUpOtpVerifyAction = createAsyncThunk(
  "auth/verifyOtpSignUp",
  async (data: SignUpOtpVerifyPayloadType) => {
    const response = await signUpOtpVerifyApi(data);
    await setCsrfToken(response);
    return response.data;
  }
);


// TEAM DIRECTORY ACTION
export const getTeamDirectoryUserListAction = createAsyncThunk(
  "auth/getTeamDirectoryUsersList",
  async (data: GetTeamDirectoryPayloadType) => {
    const response = await getTeamDirectoryUserList(data);
    return response.data;
  }
);

// MAPPED JOBS OF GOVERMENT OFFICER

export const getGovtOfficerJobsListAction = createAsyncThunk(
  "auth/getGovtOfficerJobsList",
  async (data: GetGovtOfficerJobListPayloadType) => {
    const response = await getGovtOfficerJobsListApi(data);
    return response.data;
  }
);


// pincode api
export const getPincodeAction = createAsyncThunk(
  "auth/getPincode",
  async (data: GetPincodePayloadType) => {
    const response = await getPincodeApi(data);
    return response.data;
  }
);

export const signUpOtpVerifyVoucherCodeAction = createAsyncThunk(
  "auth/verifyVoucherCode",
  async (data: any) => {
    const response = await signAuVerifyVoucherCodeApi(data);
    await setCsrfToken(response);
    return response.data;
  }
);


// Payment Gateway Action

export const createOrderAction = createAsyncThunk(
  "auth/createOrderAction",
  async (data: any) => {
    const response = await createOrder(data);
    return response.data;
  }
);

export const verifyPaymentAction = createAsyncThunk(
  "auth/verifyPaymentAction",
  async (data: any) => {
    const response = await verifyOrder(data);
    return response.data;
  }
);
